import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

import Link from 'buyside/components/presentation/Link/link';

import styles from './eventFooterStyles.scss';

const EventFooter: React.FC = () => (
  <div className={styles.footerContainer}>
    <div className={styles.footerLogo}>
      <img src="/images/logo_darkbg_350.png" />
    </div>
    <div className={styles.footerSocials}>
      <span>Stay Connected</span>
      <Link to="https://www.youtube.com/c/SumZeroInc" target="_blank">
        <FontAwesomeIcon icon={faYoutube} />
      </Link>
      <Link to="https://www.facebook.com/SumZeroInc" target="_blank">
        <FontAwesomeIcon icon={faFacebook} />
      </Link>
      <Link to="https://twitter.com/SumZero" target="_blank">
        <FontAwesomeIcon icon={faTwitter} />
      </Link>
    </div>
  </div>
);

export default EventFooter;
